import { render, staticRenderFns } from "./pdf-loader.vue?vue&type=template&id=0a3a6124"
import script from "./pdf-loader.vue?vue&type=script&lang=js"
export * from "./pdf-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports